// extracted by mini-css-extract-plugin
export default {"root":"qBL7RFKC","icon":"YhI48MwH","texts":"tbwBAv7E","title":"H0rcjYOu","subtitle":"AWbMCcgt"};